import React, {Component} from "react";
import {show} from "../../actions/sidebar";
import {connect} from "react-redux";
//import {isAdmin} from "../../helpers";

class View extends Component {

    menuItemClick(event){
        if (window.innerWidth<1024){
            const {dispatch} = this.props;
            dispatch(show());
        }
    }

  render(){

    let x= null;
    let menu = [
      // {
      //   'id':'settings',
      //   'url':'/#/settings',
      //   'title':'Inställningar',
      //   'isActive':false,
      //   'isEnabled': isAdmin(),
      //   'onClick':(e) => this.menuItemClick(e)
      // },
      // {
      //   'id':'help',
      //   'url':'/#/help',
      //   'title':'Hjälp',
      //   'isActive':false,
      //   'isEnabled':true,
      //   'onClick':(e) => this.menuItemClick(e)
      // },
      {
        'id':'logout',
        'url':'/',
        'title':'Logga ut',
        'isActive':false,
        'isEnabled':true,
        'onClick':(e) => {
          e.preventDefault();
          this.props.logout();
        }
      }
    ];


    if (this.props.location){
      for(x in menu) {
        menu[x].isActive = "/#"+this.props.location.pathname===menu[x].url;
      }
    }


    return (
      <div id="adminmenu" className="menu">
        <ul>
          {menu.map(mi =>{
            if (mi.isEnabled && typeof(mi.onClick)==="undefined"){
              return (
                <li className={mi.isActive ? mi.id+" active": mi.id}>
                  <a href={mi.url}>
                    <span>{mi.title}</span>
                  </a>
                </li>)
            } else if(typeof(mi.onClick)==="function") {

              return (
                <li key={mi.id} className={mi.isActive ? mi.id+" active": mi.id}>
                  <a onClick={mi.onClick} href={mi.url}>
                    <span>{mi.title}</span>
                  </a>
                </li>)

            } else {
              return null;
            }
          })}
        </ul>
      </div>
    );

  }

}


/**
 * Map actions to properties
 */
const mapStateToProps = (state) => ({
    isOpen: state.sidebar.isOpen
});

export default connect(mapStateToProps)(View)


// WEBPACK FOOTER //
// ./src/components/AdminMenu/View.js